export const POST_MAP = 'POST_MAP';
export const LIST_MAP = 'LIST_MAP';
